import {checkIfAlreadyProsted} from "../prost/checkIfAlreadyProsted";
import {populateCommentContainer} from "./populateCommentContainer";
import {stringToDate} from "../utils/stringToDate";
import {dateToString} from "../utils/dateToString";

export function populateComments(id, unparsedComment, communityType) {
    let data = $.parseJSON(unparsedComment);
    let comments = data.comments;
    let container = $("#"+ id);
    let modal = $("#commentModal_"+ id);
    let commentIds = "(-1";
    let commentPrototypeContainer = $("body").find(".display_comment.prototype.hidden");

    $.each(comments, function (key, comment) {
        if (shownComments[id] === undefined) {
            shownComments[id] = 1;
        } else {
            shownComments[id]++;
        }
        let dateObject = stringToDate(comment.comment_date);
        let dateString = dateToString(dateObject, true);

        let communityUser = {};
        communityUser["shop_user_id"] = comment.shop_user_id;
        communityUser["nickname"] = comment.nickname;
        communityUser["nickname_slug"] = comment.nickname_slug;
        communityUser["slogan"] = comment.slogan;
        communityUser["image"] = comment.image;

        let filledCommentContainer = commentPrototypeContainer.clone();
        filledCommentContainer.removeClass("prototype");
        filledCommentContainer.removeClass("hidden");

        filledCommentContainer.find(".prost_count_comment").text(comment.sum_prosts);
        filledCommentContainer.find(".comment_count_comment").text(comment.sum_comments);

        let linkToUser = "/" + siteCode + "/" + mainLanguageCode + "/stammtisch/profile/" + comment.nickname_slug + "/";

        let commentTextProfileContainer =
            "<div class='profile_information'>" +
            "<a class='name' href='" + linkToUser + "'>" +
            comment.nickname +
            "</a>" +
            "&nbsp;" +
            "<small>" +
            decorateDateString(comment.comment_date) +
            "</small>" +
            "</div>" +
            comment.content
        ;
        filledCommentContainer.find(".js-comment-content").html(commentTextProfileContainer);
        filledCommentContainer.attr("id", "comment_" + comment.id);

        let image = "/layout/frontend/stiegl/dist/images/no-profile-pic.png";
        if (comment.image !== null) {
            image = "/userdata/stammtisch/profile_images/resized/" + comment.image;
        }
        filledCommentContainer.find(".content .profile_image").find("img").attr("src", image);
        filledCommentContainer.find(".profile_image").find("a").attr("href", linkToUser);
        // JOK: set the correct image of the user for a comment-comment
        filledCommentContainer.find(".new_comment_comment .profile_image").find("img").attr("src", profileImageSrc);

        populateCommentContainer(id, filledCommentContainer, "pre");
        commentIds += "," + comment.id;
    });
    commentIds += ")";
    checkIfAlreadyProsted("", commentIds, shopUserId, false, 0);
    let commentLink = modal.find(".more_comments_link");
    if(!comments.length){
        console.log("no comments");
        console.log(modal.find(".comments_container"));
        modal.find(".comments_container").html("<h3>Keine Kommentare vorhanden. Sei der Erste.</h3>");
    }
    if (shownComments[id] < data.count) {
        if (commentLink.hasClass("hidden")) {
            commentLink.removeClass("hidden");
        }
    } else {
        if (!commentLink.hasClass("hidden")) {
            commentLink.addClass("hidden");
        }
    }
}